
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RtoLoadHistService } from './rto-load-hist.service';
import { LoadHist } from '../Models/LoadsData';

@Injectable({
  providedIn: 'root'
})
export class RtoSummerLoadsResolverService implements Resolve<Array<LoadHist>> {
  rtoSummerHistData: Observable<Array<LoadHist>>;
  constructor(private RtoLoadSvc: RtoLoadHistService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<LoadHist>> | Promise<Array<LoadHist>> | Array<LoadHist> {

    this.rtoSummerHistData = this.RtoLoadSvc.getRTOHistData("6-9True")
    return this.rtoSummerHistData;
  }
}
